import { render, staticRenderFns } from "./CurrencyConversionTool.vue?vue&type=template&id=810dc7cc&scoped=true"
import script from "./CurrencyConversionTool.vue?vue&type=script&lang=js"
export * from "./CurrencyConversionTool.vue?vue&type=script&lang=js"
import style0 from "./CurrencyConversionTool.vue?vue&type=style&index=0&id=810dc7cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810dc7cc",
  null
  
)

export default component.exports